import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SETTINGS_SECURITY } from '../../../routes/routes';
import { ArrowPolygon, Button, Select } from '../../../styles/GlobalComponents';
import {
  FlexBetween,
  FlexCenter,
  Label,
  SInput,
  SInputContainer
} from '../../../styles/stylesStyled';
import { SmallTxt, Subtitle, Title } from './WithdrawStyled';
import { InputBackOffice } from '../../../components/common/InputBackoffice';
import { formatUSD } from '../../../helpers/helperFunctions';
import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { WithdrawSteps } from '../Earnings/Earnings';
import countries from '../../../lib/countries';
import BottomDrawer from '../../../components/common/BottomDrawer';
import { P2 } from '../../../styles/FontStyles';
import check from '../../../assets/icons/check.svg';
import search from '../../../assets/icons/search.svg';
import { useAppSelector } from '../../../app/hooks';

interface WithdrawFinalProps {
  amount: string;
  setAmount: Dispatch<SetStateAction<string>>;
  setStep: Dispatch<SetStateAction<number>>;
}

export const WithdrawFinal = ({
  setStep,
  amount,
  setAmount
}: WithdrawFinalProps) => {
  const { info } = useAppSelector((state) => state.earnings);

  return (
    <div>
      <FlexCenter style={{ flexDirection: 'column' }}>
        <Title>Withdrawal</Title>
        <Subtitle style={{ textAlign: 'center' }}>
          Please provide the info below so we can send your withdrawal.
        </Subtitle>
      </FlexCenter>
      <Label>Amount</Label>

      <InputBackOffice
        placeholder={'Withdrawal amount'}
        style={{ marginBottom: 8 }}
        onChange={(e: string) => {
          setAmount(e.replace(/[.,\s\D]/g, ''));
        }}
        pattern='[0-9]'
        value={amount.replace(/[.,\s\D]/g, '')}
      />
      <FlexBetween style={{ width: '100%', marginBottom: 12 }}>
        <SmallTxt>
          Balance: {formatUSD(info?.totalEarnings?.availableBalance)} EUR
        </SmallTxt>
        <SmallTxt>{`Withdrawal fee: 5 EUR`}</SmallTxt>
      </FlexBetween>

      <FlexCenter style={{ flexDirection: 'column' }}>
        <Button
          w='200px'
          opacity={'true'}
          mt='30'
          disabled={
            !amount ||
            parseInt(amount) < 10 ||
            parseInt(amount) > (info?.totalEarnings?.availableBalance ?? 0)
          }
          onClick={() => setStep(WithdrawSteps.TWO_FA)}>
          Withdraw
        </Button>
      </FlexCenter>
    </div>
  );
};
